module.exports = __webpack_public_path__ + "fonts/OpenSans-Medium.f0cdede.ttf";